export default __webpack_public_path__ + "static/media/logo.5582a074.PNG";